import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'NAVIGATION_V2';

export const {action: isGoingBack} = createAction(`${domain}/IS_GOING_BACK`, (isGoingBack: boolean) => ({
    isGoingBack,
}));

export const {action: setInitialHistoryStackLength} = createAction(
    `${domain}/SET_INITIAL_HISTORY_STACK_LENGTH`,
    (length: number) => ({
        length,
    }),
);

export const {action: setCurrentHistoryStackLength} = createAction(
    `${domain}/SET_CURRENT_HISTORY_STACK_LENGTH`,
    (length: number) => ({
        length,
    }),
);
